<div [hidden]="calsTransactionPageGrid && calsTransactionPageGrid.filtersForm">
  <p [hidden]="!calsTransactionGridInProgress" class="text-center">Recent Transactions are not Available</p>
  <p [hidden]="calsTransactionGridInProgress" class="loader">Loader</p>
</div>

<div *ngIf="calsTransactionPageGrid && calsTransactionPageGrid.filtersForm">
  <div class="row">
    <div class="col-12">
      <kendo-dropdownlist
        *ngIf="accountList && accountList.length > 0 && accountType === 'CORPORATE'"
        [formControl]="selAccount"
        [data]="accountList"
        textField="accountName"
        valueField="customerId"
        [valuePrimitive]="false"
      >
      </kendo-dropdownlist>
    </div>
  </div>

  <div class="row report-info">
    <div class="col-12">
      <div class="" id="viewCALS">
        <form #form="ngForm" [formGroup]="calsTransactionPageGrid.filtersForm">
          <!-- [sort]="calsTransactionPageGrid.gridQuery.sortField || calsTransactionPageGrid.gridQuery.filterValues.portfolioSortFieldId" -->

          <div id="sortingFilter">
            <div class="row">
              <div class="col-12">
                <kendo-dropdownlist
                  formControlName="stockCodeId"
                  [data]="calsCompanies"
                  textField="description"
                  valueField="code"
                  [valuePrimitive]="true"
                >
                </kendo-dropdownlist>
              </div>
            </div>
            <div class="col-auto p-0 mt-2 mb-2" [loading]="calsTransactionGridInProgress">
              <div class="btn-group" role="group">
                <button
                  type="button"
                  class="btn btn-fill"
                  [class.btn-primary]="duration === 'all'"
                  [class.btn-outline-primary]="duration !== 'all'"
                  (click)="changeTransactionDuration('all')"
                >
                  All
                </button>
                <button
                  type="button"
                  class="btn btn-fill"
                  [class.btn-primary]="duration === '1D'"
                  [class.btn-outline-primary]="duration !== '1D'"
                  (click)="changeTransactionDuration('1D')"
                >
                  Today
                </button>
                <button
                  type="button"
                  class="btn btn-fill"
                  [class.btn-primary]="duration === '1W'"
                  [class.btn-outline-primary]="duration !== '1W'"
                  (click)="changeTransactionDuration('1W')"
                >
                  This Week
                </button>
                <button
                  type="button"
                  class="btn btn-fill"
                  [class.btn-primary]="duration === '1M'"
                  [class.btn-outline-primary]="duration !== '1M'"
                  (click)="changeTransactionDuration('1M')"
                >
                  This Month
                </button>
                <button
                  type="button"
                  class="btn btn-fill ytd"
                  [class.btn-primary]="duration === '12M'"
                  [class.btn-outline-primary]="duration !== '12M'"
                  (click)="changeTransactionDuration('12M')"
                >
                  YTD
                  <span class="popup-container">
                    <i class="icon-lg icon-help-circle"></i>
                    <span class="pop-over">From 1st of April</span>
                  </span>
                </button>
                <button
                  type="button"
                  class="btn btn-fill"
                  [class.btn-primary]="duration === 'custom'"
                  [class.btn-outline-primary]="duration !== 'custom'"
                  (click)="changeTransactionDuration('custom')"
                >
                  Custom
                </button>
              </div>
            </div>
            <div class="row custom-date" [hidden]="duration !== 'custom'">
              <div class="col-6">
                <span>From :</span>
                <span>
                  <input
                    autocomplete="off"
                    type="text"
                    bsDatepicker
                    formControlName="dateFrom"
                    [bsConfig]="datePickerConfig"
                    tabindex="21"
                  />
                </span>
              </div>
              <div class="col-6">
                <span>To :</span>
                <span>
                  <input autocomplete="off" type="text" bsDatepicker formControlName="dateTo" [bsConfig]="datePickerConfig" tabindex="21" />
                </span>
              </div>
            </div>
          </div>

          <!-- <span id="downloadTxt" [hidden]="calsTransactionGridInProgress">Download Transactions</span> -->

          <div id="gridComponent">
            <div [hidden]="calsTransactionPageGrid && calsTransactionPageGrid?.total">
              <div class="grid-message p-a">
                <p [hidden]="calsTransactionGridInProgress">No records available for this period.</p>
                <div [hidden]="!calsTransactionGridInProgress" class="loader">loader</div>
              </div>
            </div>

            <div *ngIf="calsTransactionPageGrid && calsTransactionPageGrid?.dataSource?.data?.length > 0">
              <table
                mat-table
                [dataSource]="calsTransactionPageGrid.dataSource"
                matSort
                class="mat-elevation-z1 mat-table mat-small stripe-table"
              >
                <ng-container matColumnDef="tradeDate">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Trans Date</th>
                  <td mat-cell *matCellDef="let dataItem">
                    <div style="white-space: nowrap">{{ dataItem.tradeDate }}</div>
                  </td>
                </ng-container>

                <!-- Txn Type Column -->
                <ng-container matColumnDef="transactionType">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Txn Type</th>
                  <td mat-cell *matCellDef="let dataItem">
                    <i
                      class="icon"
                      [ngClass]="{
                        'icon-arrow-up-10 sell-up': dataItem.transactionType === 'SELL',
                        'icon-arrow-down-10 buy-down': dataItem.transactionType === 'BUY'
                      }"
                    ></i>
                    <span>{{ dataItem.transactionType === 'B' ? 'Buy' : dataItem.transactionType === 'S' ? 'Sell' : 'N/A' }}</span>
                  </td>
                </ng-container>

                <!-- Stock Code Column -->
                <ng-container matColumnDef="stockCode">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Stock Code</th>
                  <td mat-cell *matCellDef="let dataItem">
                    <div style="white-space: nowrap">{{ dataItem.stockCode }}</div>
                  </td>
                </ng-container>

                <!-- Price Column -->
                <ng-container matColumnDef="price">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="content-right-k text-end">Price</th>
                  <td mat-cell *matCellDef="let dataItem" class="text-end">
                    <div style="white-space: nowrap">{{ dataItem.price | money }}</div>
                  </td>
                </ng-container>

                <!-- Quantity Column -->
                <ng-container matColumnDef="quantity">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="content-right-k text-end">Quantity</th>
                  <td mat-cell *matCellDef="let dataItem" class="text-end">
                    <div style="white-space: nowrap">{{ dataItem.quantity | number }}</div>
                  </td>
                </ng-container>

                <!-- Amount (Tk.) Column -->
                <ng-container matColumnDef="tradeValue">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="content-right-k text-end">Amount (Tk.)</th>
                  <td mat-cell *matCellDef="let dataItem" class="text-end">
                    <div style="white-space: nowrap">{{ dataItem.tradeValue | money }}</div>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="calsTransactionPageGrid.displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: calsTransactionPageGrid.displayedColumns"></tr>
              </table>
              <mat-paginator
                [pageIndex]="calsTransactionPageGrid.pageIndex"
                [length]="calsTransactionPageGrid.total"
                [pageSize]="calsTransactionPageGrid.pageSize"
                (page)="calsTransactionPageGrid.onPaginate($event)"
                [pageSizeOptions]="[5, 10, 25, 50]"
                showFirstLastButtons
              ></mat-paginator>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="text-end col-12" [hidden]="calsTransactionPageGrid && calsTransactionPageGrid?.total < 1">
      <button class="mt-1 btn btn-fill ws-loading {{ downloadingReport ? 'ws-loading-progress' : '' }}" (click)="downloadReport()">
        Download Report
      </button>
    </div>
  </div>
</div>
